export default "__VITE_ASSET__LfFx6pad__"